import { Component, HostBinding, Input } from '@angular/core';
import { AccommodationType, SaleType } from '../ngrx-store/app.state';

@Component({
  selector: 'app-feed-content',
  templateUrl: './feed-content.component.html',
  styleUrls: ['./feed-content.component.css']
})
export class FeedContentComponent {

  @Input() post!: AccommodationType | SaleType;

  /** Passed on to the card: Mark as sold / Delete on your own post (the dashboard's Post history). */
  @Input() ownerActions = false

  /** Lets the card fill its grid cell (see the CSS) - every sale and house list is a grid. */
  @HostBinding('class.card-cell') readonly cardCell = true

  get sale(): SaleType | undefined {
    return this.post?._type === 'sale' ? this.post : undefined
  }

  get accommodation(): AccommodationType | undefined {
    return this.post?._type === 'accommodation' ? this.post : undefined
  }
}
